function setAccessToken(token) {
  localStorage.setItem('accessToken', token);
}
function getAccessToken() {
  var token = localStorage.getItem('accessToken');

  if (token == null || typeof (token) == 'undefined') {
    return '';
  }

  return token;
}
function setAccessTicket(token) {
  localStorage.setItem('accessTicket', token);
}
function getAccessTicket() {
  var token = localStorage.getItem('accessTicket');

  if (token == null || typeof (token) == 'undefined') {
    return '';
  }

  return token;
}
export default {
  setAccessToken: setAccessToken,
  getAccessToken: getAccessToken,
  setAccessTicket: setAccessTicket,
  getAccessTicket: getAccessTicket
}



// WEBPACK FOOTER //
// ./src/mixins/storage.js